// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_f0-6";
export var emphasizeQuantity = "_f0-3";
export var flatBottomCorners = "_f0-5";
export var productImage = "_f0-0";
export var quantityContainer = "_f0-2";
export var tooltip = "_f0-1";
export var wrapAndEllipsesOverflow = "_f0-4";